<template>
  <van-image
    :src="imgUrl"
    :width="`${width}`"
    :height="`${height}`"
    :fit="fit"
    lazy-load
  >
    <template #loading>
      <van-loading type="spinner" size="20" />
    </template>
    <template #error>
      <img :src="goodDefaultUrl" class="error-img" />
    </template>
  </van-image>
</template>

<script>
import { getGoodDefaultImg } from '@/utils/utils'
export default {
  props: {
    imgUrl: {
      type: String,
      default: ''
    },
    width: {
      type: [Number, String],
      default: ''
    },
    height: {
      type: [Number, String],
      default: ''
    },
    fit: {
      type: String,
      default: 'fill'
    }
  },
  data() {
    return {
      goodDefaultUrl: getGoodDefaultImg()
    }
  }
}
</script>

<style lang="scss" scoped>
.error-img {
  width: 100%;
  height: 100%;
}
</style>
